module.exports = __webpack_public_path__ + "static/media/desktopScreenshot02.59a2f9a6.jpg";